import { Spin } from 'antd';
import styles from './SpinFullscreen.module.less';

export const SpinFullscreen = ({ tip }: { tip?: string }): JSX.Element => {
  return <Spin size="large" tip={tip} className={styles.SpinFullscreen} delay={100} />;
};
